export const layerValuesConfiguration = {
    displacementMapScale: 30,
    displacementMapPadding: 20,
    lightsAndShadowsOpacity: 1,
}